import { render } from "./CustomerProfilePanel.vue?vue&type=template&id=580f9279&scoped=true"
import script from "./CustomerProfilePanel.vue?vue&type=script&lang=js"
export * from "./CustomerProfilePanel.vue?vue&type=script&lang=js"

import "./CustomerProfilePanel.vue?vue&type=style&index=0&id=580f9279&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f9279"]])

export default __exports__